import { Component, ChangeDetectionStrategy } from '@angular/core';
import { WebComponent } from '@padspin/web';

@Component({
  imports: [WebComponent],
  selector: 'padspin-root',
  template: `<padspin-web />`,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: `
    :host {
      display: flex;
      flex-direction: column;
      height: 100%;
    }
  `,
})
export class AppComponent {}
